<template>
    <div>
        <div class="card">
            <div class="card-body box-shadow">

                <div class="flex">
                    <h2>Estado Por Defecto de Cada Pozo</h2>
                    <div class="flex-inline">
                        <div class="badge-rounded-min bg-red-light"></div>
                        <p>Pozo Con Restriccion</p>
                        <div class="badge-rounded-min bg-green-light"></div>
                        <p>Pozo Sin Restriccion</p>
                    </div>
                </div>

                <div class="row mb-4">
                    <div v-for="p in pozos" :key="p.id"
                        :class="`badge-rounded ${p.con_restriccion === 1? 'bg-red-light':''} ${p.con_restriccion === 0? 'bg-green-light':''}`">
                        {{p.nombre}}
                    </div>
                </div>

                <div class="flex">
                    <h2>Estado Actual de Pozos</h2>
                    


                </div>

                <div class="row">
                    <div v-for="p in pozos" :key="p.id" :class="`badge-rounded ${p.clase}`">
                        {{p.nombre}}
                    </div>
                </div>

            </div>
            <div class="card-body box-shadow">
                <div class="flex justify-between">
                    <h2>Actualizar Estado de Pozos</h2>
                    <p>Hacer Click en el Pozo para cambiar su estado</p>

                    <button class="btn btn-success" @click="actualizar_pozos()">Actualizar</button>
                </div>
                <div class="row">
                </div>
                <div class="flex my-4">
                    <div class="form-group mx-1">
                        <label class="form-control-label" for="">Desde</label>
                        <div class="input-group input-group-merge">
                            <input class="form-control" type="date" v-model="desde">
                            <!-- <pre>{{desde}}</pre> -->
                        </div>
                    </div>

                    <div class="form- mx-1">
                        <label class="form-control-label" for="">Hasta</label>
                        <div class="input-group input-group-merge">
                            <input class="form-control" type="date" v-model="hasta">
                        </div>
                        <!-- <pre>{{hasta}}</pre> -->
                    </div>
                </div>
                <!-- <pre>{{update}}</pre> -->
                <div class="row">
                    <div v-for="p in pozos_update" :key="p.id"
                        :class="`badge-rounded ${p.con_restriccion === 1? 'bg-red-light':''} ${p.con_restriccion === 0? 'bg-green-light':''}`"
                        @click="actualizar_pozo(p)">
                        {{p.nombre}}
                        <div class="badge-updated" v-if="pozo_actualizado(p)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                style="fill: #fff;transform: ;msFilter:;">
                                <path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="flex mt-6">
                    <p>
                        NOTA: Solo los pozos marcados con el símbolo
                    <div class="badge-updated-block">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                            style="fill: #fff;transform: ;msFilter:;">
                            <path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path>
                        </svg>
                    </div> serán actualizados, debido a que cambia su estado
                    </p>
                </div>

                <!-- <div class="row">
                    <table class="table table-bordered">
                        <thead>
                            <th style="width:100px">Actualizar</th>
                            <th>Pozo</th>
                            <th>Linea</th>
                            <th>Estado Pozo</th>
                        </thead>
                        <tbody>
                            <tr v-for="p in pozos_update" :key="p.id" :class="`${p.con_restriccion === 1? 'bg-red-light':''} ${p.con_restriccion === 0? 'bg-green-light':''}`">
                                <td class="text-center">
                                    <input type="checkbox" name="" id="" v-model="p.check">
                                </td>
                                <td>{{p.nombre}}</td>
                                <td>{{p.linea_texto}}</td>
                                <td>
                                    <select name="" id="" v-model="p.con_restriccion">
                                        <option :value="1">Materia Prima Con Restriccion</option>
                                        <option :value="0">Materia Prima Sin Restriccion</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->

            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data: () => ({
        pozos: [],
        pozos_update: [],
        desde: new Date().toISOString().split('T')[0],
        // hasta: new Date(Number(new Date().toISOString().split('T')[0].split('-')[0]), 11, 31).toISOString().split('T')[0],
        hasta: new Date().toISOString().split('T')[0],
    }),
    mounted() {
        this.cargar_pozos()
    },
    methods: {
        async cargar_pozos() {
            await this.axios.get(`${this.api}/pozos?limit=999999`, this.cabeceras_json).then(r => {
                this.pozos = r.data.data.data
                this.pozos.forEach(p => {
                    this.pozos_update.push({
                        id: p.id,
                        con_restriccion: p.estado_actual,
                        nombre: p.nombre,
                        linea_texto: p.linea_texto,
                        check: false
                    })
                });
                // this.pozos.forEach((p,idx) => {
                //     this.$set(this.pozos[idx],'check',false)
                // });
            })
        },

        actualizar_pozo(p) {
            if (p.con_restriccion == 1) p.con_restriccion = 0
            else p.con_restriccion = 1
        },

        pozo_actualizado(pozo) {
            return this.update.find(p => p.id == pozo.id) != null ? true : false
        },

        async actualizar_pozos() {
            await this.axios.post(`${this.api}/pozos/actualizar/estados`, this.update, this.cabeceras_json).then(r => {
                console.log('rrrr', r)
            }).catch(e => {
                console.log(e)
            })
        }
    },
    computed: {
        ...mapState(["api", "cabeceras_json", "filtros_rom"]),

        update() {
            return this.pozos_update.filter(p => p.con_restriccion != this.pozos.find(p2 => p2.id == p.id).estado_actual).map(p => {
                return {
                    id: p.id,
                    desde: this.desde + ' 00:00:00',
                    hasta: this.hasta + ' 23:59:59',
                    nombre: p.nombre,
                    clase: p.con_restriccion == 1 ? 'bg-red-light' : 'bg-green-light',
                    con_restriccion: p.con_restriccion
                }
            })
        }
    }
}
</script>
<style>

</style>